import React from "react";
import { twMerge } from "tailwind-merge";
import { Chip, Text } from "@virkesborsen/ui-component-library";
import { TailwindWrapper } from "../../../TailwindWrapper/TailwindWrapper";
export const SubscriptionCoverBanner = ({
  onClick,
  className = "",
  label,
  ...props
}) => {
  const baseClasses =
    "transition absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-5/6 w-[75%] rounded-lg p-3 cursor-pointer z-10";

  return (
    <TailwindWrapper>
      <div
        onClick={onClick}
        className={twMerge(baseClasses, className)}
        {...props}
      >
        Köp <b className="text-[#6856C3]">Treebula Plus</b> för att se {label}
      </div>
    </TailwindWrapper>
  );
};

export const SubscriptionCoverRow = ({
  onClick,
  className = "",
  children,
  shouldBlur = false,
  disableIcon = false,
  ...props
}) => {
  if (!shouldBlur) {
    return (
      <div className="flex flex-row items-center gap-1 flex-nowrap">
        {children}
      </div>
    );
  }

  return (
    <div
      className={`flex flex-row items-center gap-1 justify-between flex-nowrap ${
        !onClick ? "cursor-default" : "cursor-pointer"
      }`}
      onClick={onClick ? () => onClick() : undefined}
      {...props}
    >
      <Text
        variant="text-sm/leading-none/normal"
        className={twMerge("blur-sm flex-nowrap", className)}
      >
        000
      </Text>
      {!disableIcon && (
        <Chip
          tw
          label="Plus"
          size="small"
          className="bg-[#F6F5FE] text-[#6856C3] fill-[#6856C3]"
          icon="SparkleSimple"
        />
      )}
    </div>
  );
};
